module.exports = __webpack_public_path__ + "media/images/front/breadcrumb-92eaa9444d4b2d9be93f7f9664a22a27.svg";